import React, { Component } from "react";
/*
import imageFacebook from "../assets/images/facebook.svg";
import imageLine from "../assets/images/line-w.svg";
import imageTwitter from "../assets/images/twitter-w.svg";
import imageLinkedin from "../assets/images/linkedin-w.svg";
import imageYoutube from "../assets/images/youtube-w.svg";
import imageInstagram from "../assets/images/i-w.svg";
*/
import IntlMessages from "../utils/IntlMessages";
import { Link } from "react-router-dom";

export default class Footer extends Component {
  render() {
    return (
      <>
        <footer className="page-footer d-none d-md-block">
        <div className="footer-nav-upper" ></div> 
        <div className="footer-nav-tmb" ></div>
          <div className="container-fluid  footer-container ">
            {/* <div className="social-list" style={{ display: "none" }}>
              <ul>
                <li>
                 <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                    <img src={imageFacebook} alt="facebook" />
                  </a>
                </li>
                <li>
                  <a href="https://line.me/ti/p/%-" target="_blank" rel="noopener noreferrer">
                    <img src={imageLine} alt="Line" />
                  </a> 
                </li>
                <li>
                <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
                    <img src={imageTwitter} alt="Twitter" />
                  </a> 
                </li>
                <li>
                 <a href="https://www.linkedin.com/company/" target="_blank" rel="noopener noreferrer">
                    <img src={imageLinkedin} alt="Linkedin" />
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/user/" target="_blank" rel="noopener noreferrer">
                    <img src={imageYoutube} alt="Youtube" />
                  </a> 
                </li>
                <li>
                 <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                    <img src={imageInstagram} alt="instagram" />
                  </a> 
                </li>
              </ul>
            </div> */}
            
            <div className="d-flex  copyright  white-text ">
            <Link to="/term_condition" >
            <div class="p-2"> 
                <IntlMessages id="footer.term"></IntlMessages> 
             </div>
             </Link>
              <div class="p-2"> </div>
            
                 <div className="ml-auto  p-2">    <IntlMessages id="footer.copyright"></IntlMessages></div>
           
          
            </div>

            </div>
        </footer>
        {/* <div className="footer-bottom-line"></div> */}
      </>
    );
  }
}

// const mapStateToProps = ({ setting }) => {
// 	const { locale } = setting;
// 	return { locale };
// };

// export default connect(
// 	mapStateToProps,
// 	{}
// )(Footer);
